import { cva, VariantProps } from "cva";
import styles from "./Button.module.css";

export const buttonStyles = cva({
  base: styles.base,
  variants: {
    appearance: {
      filled: styles.filled,
      outlined: styles.outlined,
      text: styles.text,
      tonal: styles.tonal,
      glass: styles.glass,
      error: styles.error,
      success: styles.success,
    },
    shape: {
      full: styles.full,
      circle: styles.circle,
    },
    fullWidth: {
      true: styles.fullWidth,
    },
    noWrap: {
      true: styles.noWrap,
    },
    size: {
      small: styles.small,
      medium: styles.medium,
    },
  },
  defaultVariants: {
    appearance: "filled",
    shape: "full",
    fullWidth: false,
    noWrap: false,
    size: "medium",
  },
});

export type ButtonRecipeProps = VariantProps<typeof buttonStyles>;
